import React from "react";
import { getUTCDate } from "../utils/getDateAndTimeUTC";
export var DateComponent = function (props) { return (React.createElement("p", null,
    "Start Date: ",
    getUTCDate(props.createdAt))); };
